import { createSourceL10n, defineLazyL10n } from '$lib/i18n';
import { ns as componentsNs, preload as preloadComponents } from '$lib/components/_i18n';
import enUS from './locales/en-US.json';

const NS = 'prospectRegister';
const loaders = import.meta.glob<{ default: Record<string, string> }>('./locales/*.json');

export const { l10n, ns, preload } = defineLazyL10n(loaders, NS, enUS, [
	{ ns: componentsNs, preload: preloadComponents },
]);
export const sourceL10n = createSourceL10n(NS);
